export const getFormulaImageUrl = (src: string) => {
  return `https://cdn-st.stage.azure.viome.com/viome-cdn/media/app/products/${src}`;
};
